import { Vue, Component } from "vue-property-decorator";
import { PageModule } from "@/store/module/page";
@Component
export class mixin extends Vue {
  searchInfo: any = {
    order_type: -1,
    status: -1,
    payment_type: -1,
    approval_status: -1,
    course_type: -1,
    renew_type: -1,
    renew_status: -1,
    student_id: "",
    course_id: "",
    courseName: "",
    sign_type: 1,
    class_id: "",
    lesson_id: [],
    teacher_id: "",
    teacherName: "",
    make_up_status: "",
    lesson_time: [] as string[],
    sort_type: "desc",
    sort_field: "lesson_date",
    className: "",
    studentName: "",
    staffName: "",
    lesson_type: "-1",
    roll_call_status: "-1",
    class_student_full: "-1",
    student_type: "-1",
    roll_call_student_status: "-1",
    classroom_id: "",
    classroomName: "",
    order_no: "",
    time_tag: -1,
    experience_status: [] as number[],
    pay_status: -1,
    date: [],
  };
  page: number = 1;
  pageSize: number = 10;
  activeName: string = ""; // tab-pane 菜单名称
  mixinSavePageInfo(names: string, tabName?: string) {
    PageModule.SET_PAGE_INFO({
      name: names,
      key: "page",
      value: this.page,
    });
    PageModule.SET_PAGE_INFO({
      name: names,
      key: "page_size",
      value: this.pageSize,
    });
    PageModule.SET_PAGE_INFO({
      name: names,
      key: "search_info",
      value: this.searchInfo,
    });
    if (tabName) {
      PageModule.SET_PAGE_INFO({
        name: names,
        key: "tab_info",
        value: tabName,
      });
    }
  }
  mixinGetPageInfo(storeNames: string) {
    const pageData = PageModule.pageInfo[storeNames];
    if (pageData.page) {
      this.page = pageData.page;
    }
    if (pageData.page_size) {
      this.pageSize = pageData.page_size;
    }
    if (pageData.search_info) {
      this.searchInfo = pageData.search_info;
    }
    if (pageData.tab_info) {
      this.activeName = pageData.tab_info;
    }
  }
}
